import React from 'react';
import Layout from '../components/layout';
import ServiceDetails from '../templates/serviceDetails';

function PageServiceDetails() {
  return (
    <Layout>
      <ServiceDetails />
    </Layout>
  );
}

export default PageServiceDetails;
